import React, { Component, Fragment } from "react";
import { Select, Tabs, Form, Checkbox } from "antd";
import { inject, observer } from "mobx-react";
import co from "co";
import { IndexingServices } from "common/general";

const Option = Select.Option;
const TabPane = Tabs.TabPane;
const FormItem = Form.Item;

@Form.create({
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(changedFields);
	},

	mapPropsToFields(props) {
		return props.fields;
	}
})
@observer
class IndexerTierForm extends Component {
	validateForm = () => {
		return new Promise(resolve => {
			this.props.form.validateFieldsAndScroll((err, vals) => {
				resolve(err);
			});
		});
	};

	render() {		
		const tier = this.props.tier;		
		let useIndexers = this.props.form.getFieldValue(`useIndexers[${tier}]`);

		let indexerPart = "";
		if (useIndexers) {
			indexerPart = (
				<FormItem label="Indexing Services">
					{this.props.form.getFieldDecorator(`indexers[${tier}]`, {
						rules: [
							{
								required: true,
								message: (
									<span>
										Because you ticked <b>Use Indexing Services</b>. You need to
										select indexing services to help index your links
									</span>
								)
							}
						]
					})(
						<Select
							style={{ width: 400 }}
							placeholder="Select indexing services"
							mode="multiple"
						>
							{IndexingServices.map(service => {
								return (
									<Option key={service.name} id={service.name}>
										{service.text}
									</Option>
								);
							})}
						</Select>
					)}
				</FormItem>
			);
		}

		let indexingHelp = (
			<span>
				Using an indexing service may increase your chance of getting your links
				indexed by Google.{" "}
				<a href="#/options?tab=indexer" target="_blank">
					Click here
				</a>{" "}
				to configure indexing services
			</span>
		);
		return (
			<Fragment>
				<FormItem style={{ marginBottom: 10 }} extra={indexingHelp}>
					{this.props.form.getFieldDecorator(`useIndexers[${tier}]`, {
						valuePropName: "checked"
					})(
						<Checkbox>
							<span>
								Use indexing service for <b>Tier {tier + 1}</b>
							</span>
						</Checkbox>
					)}
				</FormItem>
				{indexerPart}
			</Fragment>
		);
	}
}

@inject("rootStore")
@observer
class MainTabs extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeKey: "tier1"
		};
	}

	setActiveKey = activeKey => {
		this.setState({ activeKey });
	};

	handleTabChange = activeKey => {
		this.setState({ activeKey });
	};

	render() {
		return (
			<Tabs
				tabPosition="left"
				activeKey={this.state.activeKey}
				onChange={this.handleTabChange}
				animated={false}
			>
				{this.props.tabPanes}
			</Tabs>
		);
	}
}

@inject("rootStore")
@observer
class IndexerTab extends Component {
	internalForms = [];

	mapPropsToFields = () => {
		const {
			rootStore: { xwizardStore }
		} = this.props;
		const stateForm = xwizardStore.stateForm;
		const wizard = xwizardStore.wizard;

		let data = {
			indexers: [],
			useIndexers: []
		};

		for (let i = 0; i < wizard.depth; i++) {
			let currentObj = stateForm.indexers[i];
			currentObj = { ...currentObj, value: currentObj.value.slice() };
			data.indexers.push(Form.createFormField(currentObj));
			data.useIndexers.push(Form.createFormField(stateForm.useIndexers[i]));
		}

		return data;
	};

	onFieldsChange = changedFields => {
		const {
			rootStore: { xwizardStore }
		} = this.props;
		xwizardStore.formChanged(changedFields);
	};

	validateForm = () => {
		return co(
			function*() {
				// console.log("Number of forms are: " + this.internalForms.length);
				for (let tier = 0; tier < this.internalForms.length; tier++) {
					let internalForm = this.internalForms[tier];
					let result = yield internalForm.validateForm();
					if (result != null) {
						this.mainTabs.setActiveKey(`tier${tier + 1}`);
						return result;
					}
				}
				return null;
			}.bind(this)
		);
	};

	render() {
		const {
			rootStore: { xwizardStore }
		} = this.props;
		const ui = xwizardStore.ui;
		if (ui.loading) {
			return <Fragment />;
		}
		const stateForm = xwizardStore.stateForm;
		const wizard = xwizardStore.wizard;
		let fields = this.mapPropsToFields();
		let tabPanes = [];

		this.internalForms = [];

		for (let tier = 0; tier < wizard.depth; tier++) {
			const tabName = `Tier ${tier + 1}`;
			const tabKey = `tier${tier + 1}`;
			// console.log(tabName, tabKey);
			let tabPane = (
				<TabPane
					tab={tabName}
					key={tabKey}
					forceRender={true}
					// style={{ minHeight: (window.screen.height * 60) / 100 }}
				>
					<Form>
						<IndexerTierForm
							key={tier}
							tier={tier}
							nTier={wizard.depth}
							fields={fields}
							onFieldsChange={this.onFieldsChange}
							wrappedComponentRef={internalForm => {
								if (internalForm != null) {
									this.internalForms.push(internalForm);
								}
							}}
						/>
					</Form>
				</TabPane>
			);
			tabPanes.push(tabPane);
		}

		return (
			<MainTabs
				tabPanes={tabPanes}
				ref={mainTabs => {
					if (mainTabs != null) {
						this.mainTabs = mainTabs.wrappedInstance;
					}
				}}
			/>
		);
	}
}

export default IndexerTab;
